import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./i18nResource";

// 从本地存储获取保存的语言设置，如果没有则使用默认值
const savedLanguage = localStorage.getItem('i18nextLng') || 'zh_TW';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // 使用保存的语言或默认语言：繁体中文
    fallbackLng: "zh_TW",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;